import gql from 'graphql-tag'
import { storySpotlightFragment } from '@components/story-spotlight/story-spotlight.fragment'

export const FEATURED_STORIES_QUERY = gql`
query MajorEventsLandingPage($preview: Boolean) {
  majorEventsLandingCollection(limit: 1, preview: $preview) {
    items {
      featuredStoriesHeadline
      featuredStoriesCtaText
      featuredStoriesCtaLink
      featuredStoriesCollection(limit: 5) {
        total
        items {
         ${storySpotlightFragment}
        }
      }
    }
  }
}
`
